import { Component } from '@angular/core';
import { LoadingService } from 'src/app/services/shared/loading.service';

@Component({
    selector: 'apc-loading-screen',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {

  constructor(public loadingService: LoadingService) { }
  counter = 0;

  playGame() {
    this.counter ++;
    if(this.counter === 2){
      this.loadingService.playGame = true;
      this.counter = 0;
    }
  }

}
